module.exports = __webpack_public_path__ + "img/desktop.c3544885.jpg";